/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { Consumer } from 'store/createContext';
import Modal from '../../components/modal/modal-conditions';
import { Row, Col, Label, Collapse } from 'reactstrap';
import { HintMenu, Button, ModalStyle } from './modal-conditions.css';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

class ModalConditionsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.displayValues = {};
    this.healthtyState = '';
    this.state = {
      selected: [],
      health: '',
      open: false,
      collapseCON: props.conditionsList.map(() => {
        if (typeof window !== 'undefined') {
          if (window.innerWidth > 1024) {
            return true;
          }
          return false;
        }
      }),
      collapseHV: true,
    };

    this.mounted = false;
    this.touched = false;
    this.valueChange = this.valueChange.bind(this);
    this.clearAll = this.clearAll.bind(this);
  }

  toggleCON = index => {
    let collapse = this.state.collapseCON;
    collapse[index] = !this.state.collapseCON[index];
    this.setState({ collapseCON: collapse });
    this.forceUpdate();
  };

  toggleHV = () => {
    let collapse = this.state.collapseHV;
    this.setState({ collapseHV: !collapse });
  };

  handleModal = () => {
    this.setState({ open: !this.state.open });
  };

  toggle(item) {
    // if (item.Children && item.Children.length > 0) {
    //   return false;
    // }

    let { selected } = this.state;

    if (selected.includes(item.InternalValue)) {
      selected.splice(selected.indexOf(item.InternalValue), 1);
      delete this.displayValues[item.InternalValue];
      if(item.Children) {
        item.Children.forEach((child) => {
          if (selected.includes(child.InternalValue)) {
            selected.splice(selected.indexOf(child.InternalValue), 1);
            delete this.displayValues[child.InternalValue];
          }
        })
      }
    } else {
      selected.push(item.InternalValue);
      this.displayValues[item.InternalValue] = item.DisplayValue;
      if(item.Children) {
        item.Children.forEach((child) => {
          selected.push(child.InternalValue);
          this.displayValues[child.InternalValue] = child.DisplayValue;
        })
      }
    }

    this.setState({
      selected: selected,
    });

    this.touched = true;
  }

  valueChange(event) {
    if (event && event.target) {
      this.healthtyState = `${event.target.value}`;
      this.setState({
        health: this.healthtyState,
      });
    }
    this.touched = true;
  }

  clearAll() {
    this.setState({
      selected: [],
      health: '',
    });
    this.displayValues = {};
    this.healthtyState = '';
    this.touched = true;
  }

  setPresSelected(preselected, healthValue) {
    let newData = {};
    let { conditionsList } = this.props;
    if (preselected && Array.isArray(preselected) && preselected.length) {
      newData.selected = preselected;
      if (Object.values(this.displayValues).length === 0) {
        conditionsList.forEach(item => {
          if (preselected.includes(item.InternalValue)) {
            this.displayValues[item.InternalValue] = item.DisplayValue;
          }
          if (item.Children && Array.isArray(item.Children)) {
            item.Children.forEach(subItem => {
              if (preselected.includes(subItem.InternalValue)) {
                this.displayValues[subItem.InternalValue] =
                  subItem.DisplayValue;
              }
            });
          }
        });
      }
    }

    if (healthValue && this.state.health !== healthValue) {
      this.healthtyState = healthValue;
      newData.health = this.healthtyState;
    }

    if (Object.keys(newData).length) {
      this.setState(newData);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidMount() {
    let { preselectedConditions, preselectedHealth } = this.props;
    this.mounted = true;
    this.setPresSelected(preselectedConditions, preselectedHealth);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.mounted) {
      return false;
    }

    if (this.touched) {
      return false;
    }

    // I have no idea what I did here. No idea at all
    let { preselectedConditions, preselectedHealth } = prevProps;
    if (
      (preselectedConditions &&
        preselectedConditions.length &&
        prevState &&
        prevState.selected.length > 0 &&
        this.state &&
        this.state.selected.length === 0) ||
      (preselectedHealth &&
        preselectedHealth.length &&
        prevState.health.length &&
        this.state.health.length &&
        this.state.health !== prevState.health)
    ) {
      return false;
    }

    if (
      preselectedConditions &&
      this.state.selected &&
      (preselectedConditions.join('') !== this.state.selected.join('') ||
        preselectedHealth !== this.state.health)
    ) {
      this.setPresSelected(preselectedConditions, preselectedHealth);
    }
  }

  render() {
    let {
      conditionsList,
      healthVol,
      title,
      buttonText,
      conditions,
      all,
      clear,
      accept,
      ok,
      onSelected,
      allSelected,
    } = this.props;
    const { open } = this.state;

    return (
      <Consumer>
        {() => (
          <Modal
            open={open}
            handleModal={this.handleModal}
            title={title}
            buttonText={buttonText}
            conditions={conditions}
            all={all}
            clear={clear}
            accept={accept}
            ok={ok}
            close={this.closeMod}
          >
            <ModalStyle>
              <HintMenu className={'header-mobile'}>
                <Row className={'modal-header'}>
                  <Col xs={12}>
                    <img
                      src={'/images/FiX.png'}
                      alt={''}
                      onClick={() => {
                        (onSelected &&
                          onSelected(
                            this.state.selected,
                            Object.values(this.displayValues),
                            this.healthtyState
                          )) ||
                          this.handleModal();
                      }}
                    />
                  </Col>
                  <Col xl={7} lg={7} md={12}>
                    <h4>{title}</h4>
                  </Col>
                  <Col className={'deskContent'} md={2}>
                    <button
                      onClick={() => {
                        allSelected(), this.clearAll(), this.handleModal();
                      }}
                    >
                      {all}
                    </button>
                  </Col>
                  <Col className={'deskContent'} md={2}>
                    <button
                      disabled={
                        this.state.selected.length === 0 &&
                        this.state.health === ''
                      }
                      onClick={this.clearAll}
                    >
                      {clear}
                    </button>
                  </Col>
                  <Col className={'deskContent'} md={1}>
                    <button
                      className={'ok-btn'}
                      onClick={() => {
                        (onSelected &&
                          onSelected(
                            this.state.selected,
                            Object.values(this.displayValues),
                            this.healthtyState
                          )) ||
                          this.handleModal();
                      }}
                    >
                      {ok}
                    </button>
                  </Col>
                </Row>
              </HintMenu>
              <div className={'condition-flow'}>
                {conditionsList.map((condition, index) => {
                  return (
                    <div key={index} className={'condition-col'}>
                      <div className={'childrenModal'}>
                        <div
                          className={
                            (condition.Children && condition.Children.length
                              ? ' has-children '
                              : '') +
                            (this.state.selected.includes(
                              condition.InternalValue
                            )
                              ? ' active '
                              : '')
                          }
                        >
                          <Button onClick={this.toggle.bind(this, condition)}>
                            {condition.DisplayValue}
                          </Button>
                          <div className={'phoneContent'}>
                            {this.state.collapseCON[index] === true ? (
                              <IoIosArrowUp
                                onClick={this.toggleCON.bind(this, index)}
                              />
                            ) : (
                              <IoIosArrowDown
                                onClick={this.toggleCON.bind(this, index)}
                              />
                            )}
                          </div>
                        </div>
                        <Collapse
                          className={'deskContent' + 'phoneContent'}
                          isOpen={this.state.collapseCON[index]}
                        >
                          {condition.Children && condition.Children.length && (
                            <div className={'sub-conditions'}>
                              {condition.Children.map(
                                (subCondition, subIndex) => {
                                  return (
                                    <div key={'condition_ ' + index + subIndex}>
                                      <Button
                                        onClick={this.toggle.bind(
                                          this,
                                          subCondition,
                                          condition
                                        )}
                                        className={
                                          'subConditionBtn' +
                                          (this.state.selected.includes(
                                            subCondition.InternalValue
                                          )
                                            ? ' active '
                                            : '')
                                        }
                                      >
                                        {subCondition.DisplayValue}
                                      </Button>
                                      {subIndex < condition.Children.length - 1
                                        ? ' | \u00a0'
                                        : null}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          )}
                        </Collapse>
                      </div>
                    </div>
                  );
                })}
                {healthVol && healthVol.length && (
                  <div className={'healthy-vol'}>
                    <Col>
                      <div className={'has-children'}>
                        <h3>{accept}</h3>
                        <div className={'phoneContent'}>
                          {this.state.collapseHV === true ? (
                            <IoIosArrowUp
                              className={'arrow-position'}
                              onClick={this.toggleHV}
                            />
                          ) : (
                            <IoIosArrowDown
                              className={'arrow-position'}
                              onClick={this.toggleHV}
                            />
                          )}
                        </div>
                      </div>
                      <div style={{ display: 'flex' }}>
                        <Collapse isOpen={this.state.collapseHV}>
                          {healthVol.map((volItem, volIdx) => (
                            <Label key={volIdx} className={'check-div'}>
                              <input
                                type="checkbox"
                                className={'check-box'}
                                name="radio1"
                                value={volItem.InternalValue}
                                checked={
                                  volItem.InternalValue === this.state.health
                                }
                                onChange={this.valueChange}
                                id={volIdx === 0 ? 'no-option' : 'yes-option'}
                              />
                              {volIdx === 0 ? (
                                <p>{volItem.DisplayValue}</p>
                              ) : (
                                <p>{volItem.DisplayValue}</p>
                              )}
                            </Label>
                          ))}
                        </Collapse>
                      </div>
                    </Col>
                  </div>
                )}
              </div>
              <HintMenu className={'footer'}>
                <Row className={'modal-header'}>
                  <Col xl={7} lg={7} md={0}>
                    {null}
                  </Col>
                  <div
                    className={'phoneContent'}
                    style={{
                      display: 'flex',
                      width: '100%',
                      alignItems: 'center',
                    }}
                  >
                    <Col xl={2}>
                      <button
                        onClick={() => {
                          allSelected(), this.clearAll(), this.handleModal();
                        }}
                      >
                        {all}
                      </button>
                    </Col>
                    <Col xl={2}>
                      <button
                        disabled={
                          this.state.selected.length === 0 &&
                          this.state.health === ''
                        }
                        onClick={this.clearAll}
                      >
                        {clear}
                      </button>
                    </Col>
                  </div>
                  <Col className={'deskContent'} md={2}>
                    <button
                      onClick={() => {
                        allSelected(), this.clearAll(), this.handleModal();
                      }}
                    >
                      {all}
                    </button>
                  </Col>
                  <Col className={'deskContent'} md={2}>
                    <button
                      disabled={
                        this.state.selected.length === 0 &&
                        this.state.health === ''
                      }
                      onClick={this.clearAll}
                    >
                      {clear}
                    </button>
                  </Col>
                  <Col xl={1} lg={1} md={12}>
                    <button
                      className={'ok-btn'}
                      onClick={() => {
                        (onSelected &&
                          onSelected(
                            this.state.selected,
                            Object.values(this.displayValues),
                            this.healthtyState
                          )) ||
                          this.handleModal();
                      }}
                    >
                      {ok}
                    </button>
                  </Col>
                </Row>
              </HintMenu>
            </ModalStyle>
          </Modal>
        )}
      </Consumer>
    );
  }
}

ModalConditionsContainer.propTypes = {
  conditionsList: PropTypes.array,
  preselectedConditions: PropTypes.array,
  preselectedHealth: PropTypes.string,
  healthVol: PropTypes.array,
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  conditions: PropTypes.string,
  all: PropTypes.string,
  clear: PropTypes.string,
  accept: PropTypes.string,
  ok: PropTypes.string,
  onSelected: PropTypes.func,
  allSelected: PropTypes.func,
};

export default ModalConditionsContainer;
